import { rem } from 'polished';
import styled from 'styled-components';

import { Link } from '@makemydeal/ui-bricks/dist/cox';

export const StyledLink = styled(Link)`
    padding-left: ${rem(10)};
`;
